import styled from 'styled-components'
import {colors} from '../../../styles/theme'

export const ExamBox = styled.div`
  border-top: 2px solid #ebeffc;
  margin-top: 24px;
  padding-top: 16px;
`

export const AssetDescription = styled.p`
  margin: 0;
  padding: 0;
  color: ${colors.bksGray80};
  font-size: 16px;
  line-height: 24px;
  margin-top: 24px;
`

export const ExamListBox = styled.div`
  display: flex;
  margin-top: 48px;
`

export const ExamCard = styled.div`
  border: 1px solid #ebeffc;
  border-radius: 4px;
  background: #fff;
  display: flex;
  flex-flow: column;
  gap: 24px;
  padding: 24px;
  width: 300px;
  box-sizing: border-box;
`

export const ExamCardtitle = styled.p`
  font-size: 16px;
  font-weight: 700;
  margin: 0;
  padding: 0;
  color: ${colors.bksGray80};
  display: flex;
  align-items: center;
  gap: 8px;
`

export const ExamCardButtonBox = styled.div`
  && button {
    width: 100% !important;
  }
`

export const ExamCardAttempts = styled.div`
  font-size: 14px;
  color: ${colors.bksGray70};
  line-height: 20px;

  display: flex;
  flex-flow: column;
  gap: 8px;
`
